import { useEffect, useRef, useState } from "react";
import { Loader2, Send, Trash2 } from "lucide-react";
import { formatDate } from "../lib/format";

const fmtTime = (iso) => (iso ? `${formatDate(iso.slice(0, 10))} ${iso.slice(11, 16)}` : "");

// Conversazione segnalatore <-> studio. `mine` indica il mittente "proprio" ("segnalatore" o "studio").
export const SegChat = ({ messages, mine, onSend, onDelete, loading, testPrefix = "seg-chat", light = false }) => {
  const [text, setText] = useState("");
  const [sending, setSending] = useState(false);
  const endRef = useRef(null);
  useEffect(() => { endRef.current?.scrollIntoView({ block: "end" }); }, [messages]);

  const send = async () => {
    const t = text.trim();
    if (!t) return;
    setSending(true);
    try { await onSend(t); setText(""); } finally { setSending(false); }
  };

  return (
    <div className="flex flex-col h-full min-h-[320px]" data-testid={`${testPrefix}`}>
      <div className="flex-1 overflow-y-auto space-y-2 p-3">
        {loading ? <div className="flex justify-center py-8"><Loader2 className="h-5 w-5 animate-spin text-amber-500" /></div>
          : messages.length === 0 ? <div className="text-center text-sm text-slate-500 py-8" data-testid={`${testPrefix}-empty`}>Nessun messaggio. Scrivi il primo!</div>
          : messages.map((m) => {
            const own = m.from === mine;
            return (
              <div key={m.id} className={`group flex items-center gap-1.5 ${own ? "justify-end" : "justify-start"}`} data-testid={`${testPrefix}-msg-${m.id}`}>
                {onDelete && own && (
                  <button type="button" onClick={() => onDelete(m)} title="Elimina messaggio" data-testid={`${testPrefix}-delete-${m.id}`}
                    className="opacity-40 group-hover:opacity-100 transition-opacity text-slate-500 hover:text-red-400 p-1"><Trash2 className="h-3.5 w-3.5" /></button>
                )}
                <div className="max-w-[80%] rounded-2xl px-3.5 py-2 text-sm shadow-sm"
                  style={own ? { backgroundColor: "#f59e0b", color: "#0a0d14" } : { backgroundColor: light ? "#e2e8f0" : "#1e293b", color: light ? "#0f172a" : "#e2e8f0" }}>
                  <div className="whitespace-pre-wrap break-words">{m.text}</div>
                  <div className="text-[10px] mt-1 opacity-70">{m.author} · {fmtTime(m.created_at)}</div>
                </div>
                {onDelete && !own && (
                  <button type="button" onClick={() => onDelete(m)} title="Elimina messaggio" data-testid={`${testPrefix}-delete-${m.id}`}
                    className="opacity-40 group-hover:opacity-100 transition-opacity text-slate-500 hover:text-red-400 p-1"><Trash2 className="h-3.5 w-3.5" /></button>
                )}
              </div>
            );
          })}
        <div ref={endRef} />
      </div>
      <div className="border-t border-slate-800 p-2 flex gap-2 items-end">
        <textarea value={text} onChange={(e) => setText(e.target.value)} rows={2} placeholder="Scrivi un messaggio…"
          onKeyDown={(e) => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); send(); } }}
          data-testid={`${testPrefix}-input`}
          className="flex-1 resize-none rounded-md border border-slate-700 bg-slate-900/40 px-3 py-2 text-sm text-slate-100 focus:outline-none focus:border-amber-500" />
        <button type="button" onClick={send} disabled={sending || !text.trim()} data-testid={`${testPrefix}-send`}
          className="h-10 px-4 rounded-md bg-amber-500 hover:bg-amber-600 text-[#0a0d14] font-semibold text-sm inline-flex items-center gap-1.5 disabled:opacity-50">
          {sending ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />} Invia
        </button>
      </div>
    </div>
  );
};
